import { globalEntitlements } from '../utils/globalEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const SALES_TAX_REGISTRATION_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [],
        productName: 'productPage.salesTaxRegistration.buyBox.productName',
        interactService: {
          ctaType: 'externalCheckout',
          service: 'sales_tax_registration',
          openInNewTab: true,
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/approved-stamp-document.png',
      alt: 'productPage.salesTaxRegistration.heroPicture.altText',
    },
    headline: 'productPage.salesTaxRegistration.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.salesTaxRegistration.page.subheader',
  },
  benefit: {
    title: 'productPage.salesTaxRegistration.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/securityrounded.svg',
        title: 'productPage.salesTaxRegistration.valueProp.propTitle1',
        description: 'productPage.salesTaxRegistration.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/folderopenrounded.svg',
        title: 'productPage.salesTaxRegistration.valueProp.propTitle2',
        description: 'productPage.salesTaxRegistration.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.salesTaxRegistration.valueProp.propTitle3',
        description: 'productPage.salesTaxRegistration.valueProp.shortCopy3',
      },
    ],
  },
  assistance: {
    title: 'productPage.salesTaxRegistration.needAssistance.title',
    getInTouch: 'productPage.salesTaxRegistration.needAssistance.getInTouch',
    actions: 'productPage.salesTaxRegistration.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.salesTaxRegistration.buyBox.buttonLabel',
  })
    .allowMultiplePurchases()
    .build(),
};
